export default __webpack_public_path__ + "static/media/logout_icon_red.746ca53e.svg";